import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
export function ProofSection() {
  return <section className="py-24 bg-zinc-950 border-t border-zinc-900" data-id="element-146">
      <div className="max-w-4xl mx-auto px-6 md:px-12" data-id="element-147">
        <div className="flex flex-wrap justify-center gap-4 mb-12" data-id="element-148">
          {['30 DAYS', '$5K+ RETAINERS', '7-FIGURE FRAMEWORKS'].map((stat, i) => <motion.div key={i} initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="px-4 py-2 rounded-full bg-zinc-900 border border-zinc-800 text-amber-500 font-bold text-sm tracking-widest" data-id="element-149">
                {stat}
              </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="relative bg-zinc-900/30 border border-zinc-800 p-8 md:p-12 rounded-xl text-center" data-id="element-150">
          <Quote className="absolute top-6 left-6 w-12 h-12 text-zinc-800 rotate-180" data-id="element-151" />
          <Quote className="absolute bottom-6 right-6 w-12 h-12 text-zinc-800" data-id="element-152" />

          <p className="text-2xl md:text-3xl text-zinc-300 font-medium leading-relaxed relative z-10" data-id="element-153">
            In 30 days, you will shift from a "Job Seeker" waiting for a call to
            a "Consultant" managing a pipeline. This system is built on the same
            cold-outreach and value-pricing frameworks used by 7-figure
            consulting firms—distilled into a survival map for the tech vet.
          </p>
        </motion.div>
      </div>
    </section>;
}